import Loader from '@/legacy-src/components/Loader'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { DialogTitle } from '@/src/domains/design-system/components/Dialog'

export function AiSetupProviderDialogLoader() {
  const { t } = getTranslate()

  return (
    <>
      <DialogTitle className="sr-only">{t('component.ai.passphrase.dialogTitle')}</DialogTitle>
      <Loader visible loaderType="section-large" />
    </>
  )
}
